<template>
  <div>
    <template v-for='(f,index) in formRenderStruct'>
      <div v-if='!f.is_default' :key='`${f.field}_${index}`' style='width: 100%;display: flex;flex-direction: column;'>

        <div style='display: flex;justify-content: flex-start;align-items: flex-start;gap: 5px;margin-bottom: 5px'>
          <div class='label' style='width: auto;font-weight: bolder;display: inline-block'>{{ calcColName(f.field, f.title) }}：</div>
          <div class='form-input-readonly' v-if="f.type==='select'" :style='`width: ${f.width||"100%"}`' :title='`${f.field}`'>
            {{ Array(formData[f.field]).join(',') || '' }}
          </div>
          <div class='form-input-readonly' v-else-if='f.type==="switch"' :style='`width: ${f.width||"100%"}`' :title='`${f.field}`'>
            {{ f?.switchMap[formData[f.field]]?.label }}
          </div>
          <div class='form-input-readonly' v-else-if="f.type==='rich_txt'" v-html='formData[f.field]'
               :style='`width: ${f.width||"98%"}`' :title='`${f.field}`'></div>
          <div class='form-input-readonly' v-else :style='`width: ${f.width||"100%"}`' :title='`${f.field}`'>{{ formData[f.field] || '/' }}
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PlcFormView',
  props: {
    formData: {
      type: Object
    },
    formRenderStruct: {
      type: Array,
      default() {
        return [
          {
            'title': '粉丝（万）',
            'field': 'fans_total',
            'type': 'number',
            'width': '50%',
            'placeholder': '粉丝数导出时格式化，单位：万个',
            'is_auto': true,
            'slotName': 'fans',
            'showSlot': true
          },
          {
            'title': '预估粉丝数',
            'field': 'pre_fans_total',
            'placeholder': '下月底预估粉丝量，必填（单位：个）',
            'type': 'number',
            'is_auto': true
          },
          {
            'title': '开通星图',
            'field': 'opened_star',
            'type': 'switch',
            'is_auto': true,
            'switchMap': {
              'Y': {
                'label': '开通',
                'value': 'Y'
              },
              'N': {
                'label': '未开通',
                'value': 'N'
              }
            }
          }
        ]
      }
    },
    setting: {
      type: Object,
      default() {
        return {
          columns_data: []
        }
      }
    }
  },
  data() {
    return {
      label_width: '150px',
      input_width: '360px'
    }
  },
  methods: {
    // eslint-disable-next-line
    calcColName(field, title) {
      const columns = this.setting.columns_data
      const obj = columns.find(value => value.field === field)
      return obj ? obj.title : title
    }
  }
}
</script>

<style scoped>
.fl-row * {
  box-sizing: border-box;
}

.fl-row {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 0;
  align-items: center;
  width: 100%;
  flex-wrap: wrap;

}

.fl-row .fl-col {
  width: 49%;
}

.form-input-readonly {
  border: #f2f2f2 1px solid;
  padding: 2px 10px;
  border-radius: 4px;
  width: auto;
  max-height: 300px;
  overflow-y: scroll;
}
</style>
